module.exports = __webpack_public_path__ + "static/media/podcastBadgeLevel2Locked.29febbfd.png";